import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import APIKeyManager from "./APIKeyManager";

export default function APITokenPage() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <APIKeyManager />
    </DashboardLayout>
  );
}
